import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LogService } from '../../shared/log/log.service';
import { AuthenticationStore } from '../../permission/services/authentication.store';

@Component({
  selector: 'pioneer-logout',
  templateUrl: './logout.component.html'
})
export class LogoutComponent implements OnInit {

  errorMessage: string = null;

  constructor(public router: Router,
              public authenticationStore: AuthenticationStore,
              private logService: LogService) {
    this.logService.verbose('LogoutComponent constructor');
  }

  ngOnInit() {
    this.errorMessage = null;
  }

  onLogout() {
    this.authenticationStore.logout();
    this.router.navigate([ 'login' ]);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/auth/logout/logout.component.ts